var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconZip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1922_6138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50001 13.0003L2.76251 8.70216C1.62501 7.31281 1.22688 6.50031 1.21876 5.15968C1.21734 4.47393 1.35484 3.79498 1.62294 3.1638C1.89106 2.53262 2.28424 1.96228 2.77876 1.48718C3.78291 0.533313 5.11502 0.00146485 6.50001 0.00146484C7.885 0.00146484 9.21708 0.533313 10.2212 1.48718C10.7158 1.96228 11.109 2.53262 11.3771 3.1638C11.6452 3.79498 11.7827 4.47393 11.7812 5.15968C11.7812 6.53281 11.375 7.31281 10.2131 8.73466L6.50001 13.0003ZM6.50001 1.62531C5.53461 1.61844 4.60466 1.98867 3.90813 2.65718C3.5685 2.97724 3.29864 3.364 3.11549 3.79323C2.93234 4.22246 2.83983 4.6849 2.84376 5.15156C2.89711 6.04892 3.27211 6.897 3.90001 7.54031L6.50001 10.5628L9.07562 7.57281C9.72075 6.91906 10.105 6.05231 10.1562 5.13531C10.1616 4.6704 10.0704 4.20942 9.88869 3.7815C9.70686 3.35357 9.43832 2.96798 9.1 2.64906C8.39922 1.98302 7.46676 1.61586 6.50001 1.62531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 4.0625H4.875V7.3125H8.125V4.0625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1922_6138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZip);
export default __webpack_public_path__ + "static/media/icon-zip.3435f87316daed234db78ecff8080180.svg";
export { ForwardRef as ReactComponent };